import create from 'zustand';
import { persist } from 'zustand/middleware';

interface IAct {
  accesstoken: string;
  setAccesstoken: (token: string) => void;
}

interface ICS {
  checkSum: string;
  setCheckSum: (token: string) => void;
}

const ZAct = create<IAct>()(
  persist(
    (set) => ({
      accesstoken: '',
      setAccesstoken: (status) => {
        set((state) => ({ ...state, accesstoken: status }));
      }
    }),
    { name: 'act' }
  )
);

const ZCS = create<ICS>()(
  persist(
    (set) => ({
      checkSum: '',
      setCheckSum: (status) => {
        set((state) => ({ ...state, checkSum: status }));
      }
    }),
    { name: 'cs' }
  )
);

export { ZAct, ZCS };
